export interface MapboxOutput {
  attribution: string;
  features: Feature[];
  query: [];
}

export interface Feature {
  place_name?: string;
  place_type?: string;
  place_name_it?: string;
  type?: string;
  id?: number;
  geometry?: Geometry;
  properties?: Properties;
  context?: Context[];
  text_it?: string;
}

export interface Context {
  id: string;
  text_it: string;
  text: string;
  wikidata: string;
  language_it: string;
  language: string;
  short_code: string;
}

export interface Geometry {
  type: string;
  coordinates: number[];
}

export interface Tilequery {
  distance: number;
  geometry: string;
  layer: string;
}

export interface Properties {
  Shape_Leng: number;
  CP20_COD: number;
  POP_2011: number;
  CP20_C1: string;
  CP20_DEN: string;
  OBJECTID: number;
  Shape_Area: number;
  tilequery: Tilequery;
  CU20_COD?: number;
  CU20_C1: string;
  CU20_DEN: string;
  SP20_COD?: number;
  SP20_C1: string;
  SP20_DEN: string;
  SU20_C1: string;
  SU20_COD?: number;
  SU20_DEN: string;
}

const mapBoxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const search_word = async (query: string) => {
  const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';

  const data: MapboxOutput = await (
    await fetch(
      url +
        query +
        '.json?types=place,address&country=IT&language=it&access_token=' +
        mapBoxAccessToken
    )
  ).json();

  return data.features;
};

export const searchCollegi = async (lat: number, lon: number) => {
  const url =
    'https://api.mapbox.com/v4/aurelianv.Circo_Camera_2020_tileset/tilequery/';

  const data: MapboxOutput = await (
    await fetch(
      url +
        lon +
        ',' +
        lat +
        '.json?layers=CAMERA_CollegiUN_2020,SENATO_CollegiUN_2020&access_token=' +
        mapBoxAccessToken
    )
  ).json();

  return data.features;
};
